<template>
  <v-card tile flat class="my-5">
    <v-card-text class="pa-0">
      <v-row no-gutters>
        <v-col cols="2">
          <div class="bg-kiri"></div>
        </v-col>
        <v-col cols="10" class="pa-5">
          <h1 class="headline info--text"> 3. Menunggu Penetapan Sebaran </h1>
          <h3 class="black--text font-weight-regular">Menunggu Proses Penentuan Sebaran KS oleh Pusat</h3>
          <p class="body-2 mt-4 black--text">
            Pada tahap ini Anda hanya menunggu proses penentuan sebaran Kepala Sekolah yang akan diterima pada tiap
            jenjang yang telah diajukan sebelumnya. Anda teah mengajuakan Borang Peringkat pada:
          </p>
          <span class="subtitle-1 secondary--text">{{ getInfoAjuan }} WIB</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'konfirmasi-content',

  computed: {
    ...mapState('peringkat', {
      pspPeringkat: (state) => state.psp_peringkat || {},
    }),

    getInfoAjuan() {
      const tahaps = (this.pspPeringkat && this.pspPeringkat.psp_peringkat_tahaps) || [];
      const tahap = tahaps.filter((tahap) => +tahap.k_tahap_peringkat_psp === 4);

      return this.$localDate((tahap[0] && tahap[0]['wkt_proses']) || '', false, true);
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
